@if (counts && (counts > limit)) {
  <div class="table-footer-wrapper">
    <div class="table-footer">
      <div class="mt-pagination-page col-md-10">
        <mt-btn class="mt-page" [disabled]="currentPage === 1" (onAction)="goToPage(1)">
          <mat-icon>first_page</mat-icon>
        </mt-btn>
        <mt-btn class="mt-page" [disabled]="currentPage === 1" (onAction)="goToPage(currentPage - 1)">
          <mat-icon>chevron_left</mat-icon>
        </mt-btn>
        @if ((currentPage - range) > 1) {
          <mt-btn class="mt-page"> ... </mt-btn>
        }
        @for (page of pages; track page) {
          <mt-btn class="mt-page {{currentPage === page ? 'active' : ''}}" (onAction)="goToPage(page)"
          [disabled]="currentPage === page">{{ page }}</mt-btn>
        }
        @if ((currentPage + range) > totalPages) {
          <mt-btn class="mt-page"> ... </mt-btn>
        }
        <mt-btn class="mt-page" [disabled]="currentPage === totalPages" (onAction)="goToPage(currentPage + 1)">
          <mat-icon>chevron_right</mat-icon>
        </mt-btn>
        <mt-btn class="mt-page" [disabled]="currentPage === totalPages" (onAction)="goToPage(totalPages)">
          <mat-icon>last_page</mat-icon>
        </mt-btn>
      </div>
      <div class="page-length-select col-md-4">
        <mat-form-field appearance="outline" class="moneytor-input small m-footer-page">
          <mat-select name="pageLength" placeholder="Page length" [(ngModel)]="limit"
            (selectionChange)="onLimitChange($event.value)">
            @for (page of pageLegths; track page) {
              <mat-option [value]="page">
                {{ page }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
}
